// import React from "react";
// import "./physiotherapy.css";
// import InquiryForm from "../InquiryForm";
// const PhysiotherapyAustralia = () => {
//   return (
//     <div className="physio-container">
//       <h1 className="physio-title">Physiotherapy Career in Australia</h1>

//       <div className="physio-box">
//         <h2>Overview</h2>
//         <p>
//           Physiotherapists in Australia are essential to the healthcare system,
//           supporting recovery from injuries, surgeries, and chronic conditions.
//           The profession is in high demand, particularly in rural regions.
//         </p>
//       </div>

//       <div className="physio-box">
//         <h2>Eligibility & Requirements</h2>
//         <ul>
//           <li>Bachelor’s or Master’s degree in Physiotherapy.</li>
//           <li>Registration with the Physiotherapy Board of Australia (AHPRA).</li>
//           <li>Good communication skills and clinical experience.</li>
//         </ul>
//       </div>

//       <div className="physio-box">
//         <h2>Job Prospects</h2>
//         <p>
//           Physiotherapists earn between AUD 65,000 to AUD 95,000 annually,
//           with excellent career growth and opportunities for specialization.
//         </p>
//       </div>

//       {/* Inquiry Form */}
//          <InquiryForm title="Inquire About Australia Programs" />
//     </div>
//   );
// };

// export default PhysiotherapyAustralia;

import React from "react";
import "./physiotherapy.css";
import InquiryForm from "../InquiryForm";

const PhysiotherapyAustralia = () => {
  return (
    <div className="physio-container">

      {/* Hero */}
      <section className="physio-hero">
        <div className="physio-hero-content">
          <span className="physio-country-badge">🇦🇺 Australia</span>
          <h1>Physiotherapy Career in Australia</h1>
          <p>High demand · PR pathway · Excellent work-life balance</p>
        </div>
      </section>

      {/* Overview */}
      <section className="physio-section">
        <div className="physio-box full-width">
          <div className="box-icon">🌏</div>
          <h2>Overview</h2>
          <p>
            The primary exam required for internationally trained physiotherapists seeking
            registration to practice in Australia is the Australian Physiotherapy Council
            (APC) exam. This exam assesses the knowledge, skills, and competency of
            physiotherapists to ensure they meet Australian standards. To work as a
            physiotherapist in Australia, international students need to go through a
            registration process with the Australian Physiotherapy Council and AHPRA,
            and may need a relevant visa. The assessment process with the Council is a
            crucial first step for overseas-qualified physiotherapists.
          </p>
        </div>
      </section>

      {/* APC Exam */}
      <section className="physio-section">
        <div className="physio-box">
          <div className="box-icon">📝</div>
          <h2>APC Examination</h2>
          <ul className="physio-list">
            <li>
              <strong>APC Exam:</strong> A comprehensive assessment that includes both a
              written and practical component.
            </li>
            <li>
              <strong>Purpose:</strong> Designed to evaluate the candidate's theoretical
              understanding, clinical reasoning abilities, and practical skills.
            </li>
            <li>
              <strong>Exam Type:</strong> Written & Clinical Examination.
            </li>
          </ul>
        </div>

        <div className="physio-box">
          <div className="box-icon">🏥</div>
          <h2>Registration Process</h2>
          <ul className="physio-list">
            <li>Apply to the Australian Physiotherapy Council (APC)</li>
            <li>Document assessment of overseas qualifications</li>
            <li>Complete APC written and clinical exams</li>
            <li>Register with AHPRA to practice</li>
            <li>Apply for appropriate work visa</li>
          </ul>
        </div>
      </section>

      {/* Salary */}
      <section className="physio-section">
        <div className="physio-box salary-card">
          <div className="box-icon">💰</div>
          <h2>Salary in Australia</h2>
          <div className="salary-grid">
            <div className="salary-item">
              <span className="salary-label">Starting Salary</span>
              <span className="salary-value">AUD $65,000 – $80,000<small>/year</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Experienced</span>
              <span className="salary-value">AUD $90,000 – $120,000<small>/year</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Private / Sports</span>
              <span className="salary-value">Even Higher</span>
            </div>
          </div>
          <p className="salary-inr">
            📌 In INR: approximately <strong>₹35 lakh – ₹70 lakh/year</strong>
          </p>
        </div>
      </section>

      <InquiryForm title="Inquire About Australia Programs" />
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default PhysiotherapyAustralia;